var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icon/Fill/file-add" } }, [
        _c("path", {
          attrs: {
            id: "Mask",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M14.714 8C14.32 8 14 7.619 14 7.15V3.978L17.742 8H14.714ZM14 15H13V16C13 16.552 12.553 17 12 17C11.447 17 11 16.552 11 16V15H10C9.447 15 9 14.552 9 14C9 13.448 9.447 13 10 13H11V12C11 11.448 11.447 11 12 11C12.553 11 13 11.448 13 12V13H14C14.553 13 15 13.448 15 14C15 14.552 14.553 15 14 15ZM19.74 7.328L15.296 2.328C15.107 2.119 14.838 2 14.556 2H6.556C5.147 2 4 3.122 4 4.5V19.5C4 20.878 5.147 22 6.556 22H17.444C18.854 22 20 20.878 20 19.5V8C20 7.751 19.907 7.512 19.74 7.328Z",
            fill: _vm.color
          }
        }),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "4",
              y: "2",
              width: "16",
              height: "20"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M14.714 8C14.32 8 14 7.619 14 7.15V3.978L17.742 8H14.714ZM14 15H13V16C13 16.552 12.553 17 12 17C11.447 17 11 16.552 11 16V15H10C9.447 15 9 14.552 9 14C9 13.448 9.447 13 10 13H11V12C11 11.448 11.447 11 12 11C12.553 11 13 11.448 13 12V13H14C14.553 13 15 13.448 15 14C15 14.552 14.553 15 14 15ZM19.74 7.328L15.296 2.328C15.107 2.119 14.838 2 14.556 2H6.556C5.147 2 4 3.122 4 4.5V19.5C4 20.878 5.147 22 6.556 22H17.444C18.854 22 20 20.878 20 19.5V8C20 7.751 19.907 7.512 19.74 7.328Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "24", height: "24", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }